var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorPicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#15274B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.457 15.957L12.021 7.39303L10.607 5.97903L2.043 14.543L3.457 15.957ZM9.192 4.56503L7.778 3.15103L9.192 1.73703L10.96 3.50403L13.789 0.676026C13.9765 0.488555 14.2308 0.38324 14.496 0.38324C14.7612 0.38324 15.0155 0.488555 15.203 0.676026L17.324 2.79703C17.5115 2.98455 17.6168 3.23886 17.6168 3.50403C17.6168 3.76919 17.5115 4.0235 17.324 4.21103L14.496 7.04003L16.263 8.80803L14.849 10.222L13.435 8.80803L4.243 18H0V13.757L9.192 4.56503Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/color-picker.87a1d8c68ad9de5d802ccd8b9362d222.svg";
export { ForwardRef as ReactComponent };